import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Dynamic imports using Vite — unwrap module.default so JSON keys like "default" stay strings
const loadLocaleNamespace = (key, value) => [
  key.replace(/.*\/locales\/(en|tr)\//, '').replace('.json', ''),
  value?.default ?? value,
];

const resources = {
  en: Object.fromEntries(
    Object.entries(
      import.meta.glob('../locales/en/*.json', { eager: true })
    ).map(([key, value]) => loadLocaleNamespace(key, value))
  ),
  tr: Object.fromEntries(
    Object.entries(
      import.meta.glob('../locales/tr/*.json', { eager: true })
    ).map(([key, value]) => loadLocaleNamespace(key, value))
  ),
};

i18n.use(initReactI18next).init({
  resources,
  lng: import.meta.env.VITE_DEFAULT_LANGUAGE || 'tr', // Default language
  fallbackLng: 'en',
  interpolation: { 
    escapeValue: false
  },
  // Simple configuration for production builds
  debug: import.meta.env.DEV,
  initImmediate: false,
});

export default i18n;
